import { FC } from 'react';

import { styled } from '@mui/material/styles';
import Box from '@o2/ui/Box';
import { buttonClasses } from '@o2/ui/Button';

const StyledBox = styled(Box)(() => ({
  [`& + .${buttonClasses.root}`]: {
    gridColumnStart: 1,
  },
}));

/**
 * Places the next LinkBox onto a new line.
 */
const RowBreak: FC = (props) => <StyledBox {...props} />;

RowBreak.displayName = 'PageActionButtonContainer.RowBreak';

export default RowBreak;
